import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from "./Sidebar"; // Your existing Sidebar
import Header from "./Header"; // Your existing Admin Header
import { useAuth } from './AuthContext';

export default function AdminLayout() {
  const { user, loading } = useAuth();

  // 1. Wait for Auth load
  if (loading) return <div>Loading...</div>;

  // 2. Protect the route (Redirect to login if not logged in)
  if (!user) {
    return <Navigate to="/admin-login" replace />;
  }

  // 3. Render the Layout
  return (
    <div className="flex">
      {/* Pass any props to Sidebar if needed */}
      <Sidebar />

      <div className="flex-1 ">
        <Header />
        
        <main className="flex-1  p-4">
          <Outlet /> 
        </main>
      </div>
    </div>
  );
}